






































import Vue from 'vue'
import NewYorkPostListItem from './NewYorkPostListItem.vue'
import { CategoryTreeNodeType } from '../../models/CategoryTreeNode'
import { unwrapCategoryTree } from '../../helper/index'

export default Vue.extend({
  components: {
    NewYorkPostListItem
  },
  props: {
    categoryTree: {
      type: Object
    },
    completedPosts: {
      type: Set,
      default: () => new Set()
    },
    level: {
      type: Number,
      default: 0
    },
    available: {
      type: Boolean,
      default: true
    },
    templateId: String
  },
  mounted() {
    this.orderSelectedCategoryData(this.categoryTree)
  },
  data() {
    return {
      categoryArrays: []
    }
  },
  methods: {
    nodeIsPost(type: CategoryTreeNodeType) {
      return type === CategoryTreeNodeType.Post
    },
    orderSelectedCategoryData(tree: CategoryTreeNodeType) {
      this.categoryArrays = unwrapCategoryTree(tree, false)
    }
  },
  watch: {
    categoryTree: function(newVal: CategoryTreeNodeType) {
      this.orderSelectedCategoryData(newVal)
    }
  }
})
